import React from 'react';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import blogPosts from '../data/dbPosts';
import ReactMarkdown from 'react-markdown';


const PageBlogPost = () => {
    const { slug } = useParams();
    const post = blogPosts.find((p) => p.slug === slug);

    const highlightSparklingEmail = (text) =>
        text.split(/(Sparkling Email)/g).map((part, index) =>
            (part === 'Sparkling Email')
                ? (<span key={index} className="sparklingemail-confetti">{part}</span>)
                : (part)
        );

    if (!post) {
        return (
            <section className="container py-5 text-center">
                <h1 className="display-5">Post Not Found</h1>
                <p>The article you’re looking for doesn’t exist.</p>
            </section>
        );
    }

    return (
        <>
            <Helmet>
                <title>{post.title} | Sparkling Email</title>
                <meta name="description" content={post.excerpt} />
                <meta property="og:type" content="article" />
                <meta property="og:title" content={post.title} />
                <meta property="og:description" content={post.excerpt} />
                <meta property="og:image" content={post.image || 'https://sparklingemail.com/logo.png'} />
                <meta property="og:url" content={`https://sparklingemail.com/blog/${post.slug}`} />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@sparklingemail" />
                <meta name="twitter:title" content={post.title} />
                <meta name="twitter:description" content={post.excerpt} />
                <meta name="twitter:image" content={post.image || 'https://sparklingemail.com/logo.png'} />
                <meta property="article:published_time" content={post.date} />
                <meta property="article:author" content="Sparkling Email" />
                {post.tags.map(tag => (
                    <meta key={tag} property="article:tag" content={tag} />
                ))}
                <link rel="canonical" href={`https://sparklingemail.com/blog/${post.slug}`} />
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Article",
                        "headline": post.title,
                        "image": post.image,
                        "datePublished": post.date,
                        "author": {
                            "@type": "Person",
                            "name": post.author
                        },
                        "publisher": {
                            "@type": "Organization",
                            "name": "Sparkling Email",
                            "logo": {
                                "@type": "ImageObject",
                                "url": "https://sparklingemail.com/logo.png"
                            }
                        },
                        "description": post.excerpt,
                        "keywords": post.tags.join(", ")
                    })}
                </script>
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "BreadcrumbList",
                        "itemListElement": [
                            { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://sparklingemail.com/" },
                            { "@type": "ListItem", "position": 2, "name": "Blog", "item": "https://sparklingemail.com/blog" },
                            { "@type": "ListItem", "position": 3, "name": post.title, "item": `https://sparklingemail.com/blog/${post.slug}` }
                        ]
                    })}
                </script>
            </Helmet>

            <section className="container py-5 text-dark">
                <div className="row justify-content-center mb-4">
                    <div className="col-12 col-md-10">
                        <nav aria-label="breadcrumb" className="mb-4">
                            <ol className="breadcrumb bg-transparent p-0 m-0 d-flex align-items-center">
                                <li>
                                    <a href="/" className="text-decoration-none text-muted">Home</a>
                                    <i className="fa fa-chevron-right mx-2 text-muted fs-9 pt-1" aria-hidden="true" />
                                </li>
                                <li>
                                    <a href="/blog" className="text-decoration-none text-dark">Blog</a>
                                    <i className="fa fa-chevron-right mx-2 text-muted fs-9 pt-1" aria-hidden="true" />
                                </li>
                                <li className="text-muted text-truncate d-inline-block" style={{ maxWidth: '60%' }}>
                                    {post.title}
                                </li>
                            </ol>
                        </nav>
                        <img
                            src={post.image || '/images/placeholder.jpg'}
                            className="img-fluid mb-4 rounded shadow-sm"
                            alt={post.title}
                            style={{ maxHeight: '400px', objectFit: 'cover', width: '100%' }}
                            loading="lazy"
                        />
                        <h1 className="display-5 mb-3 fw-medium">{post.title}</h1>
                        <p className="text-muted mb-4">{post.date} • {post.author} • {post.tags.join(', ')}</p>
                        <hr />
                        <div
                            className="markdown-body"
                            style={{
                                fontSize: '1.1rem',
                                lineHeight: '1.6',
                            }}
                        >
                            <ReactMarkdown
                                components={{
                                    h1: ({ _node, ...props }) => <h2 {...props} />,
                                    p: ({ _node, children }) => <p>{(typeof children === 'string') ? highlightSparklingEmail(children) : children}</p>,
                                }}>
                                {post.content || 'Coming soon...'}
                            </ReactMarkdown>

                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default PageBlogPost;